import { User } from '../lib/entities';

const createRecipientContent = (user: User) => {
	return [
		{
			type: 'recipient',
			attrs: {
				id: user.username,
				record: user,
			},
		},
		{
			type: 'text',
			text: ' ',
		},
	];
};

export const createContent = (...users: User[]) => {
	return {
		type: 'doc',
		content: [
			{
				type: 'paragraph',
				content: users.map(createRecipientContent).flat(),
			},
		],
	};
};
